
<div id="content" class="main-content">
    <div class="container">
        <div class="col-12 pl-0">
            <div class="crumbs breadcrumbs-style-2">
                <ul class="breadcrumb">
                    <li class="mt-3"><a href="dashboard" routerLink="/dashboard"><i class="flaticon-home-fill"></i></a>
                    </li>
                    <li class="active mt-3 current_arian"><a href="javascript:void(0);" class="current_arian">Statistiques de {{connectedCompany}}</a></li>
                </ul>
            </div>
        </div>
        <div class="page-header">
            <div class="page-title col-lg-8 col-md-8 col-sm-12 col-xs-12 justify-content-between">
                <h2 style="color:black"><b>Statistiques des commerciaux</b></h2>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-6 layout-spacing container_amcharts">
                <div class="statbox widget box box-shadow">
                    <div class="widget-header">
                        
                        <div class="row">
                            <div class="col-xl-12 col-md-12 col-sm-12 col-12">
                                <h4>Nombre de visites par commercial</h4>
                            </div>
                                                                
                        </div>
                    </div>
                    <div class="widget-content widget-content-area area_amcharts">
                        <div class="row">
                            <div *ngIf="loadingVisitStatistics" class="cp-spinner cp-bubble" style="margin: auto;display: block;margin-top: 15%;
                                margin-bottom: 15%;">
                            </div>
                            <div class="col-lg-12 mb-4" *ngIf="!loadingVisitStatistics">
                                <div class="container_chart">
                                    <div id="myChart_visits"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 layout-spacing container_amcharts">
                <div class="statbox widget box box-shadow">
                    <div class="widget-header">
                        
                        <div class="row">
                            <div class="col-xl-12 col-md-12 col-sm-12 col-12">
                                <h4>Nombre d'actions par commercial</h4>
                            </div>
                                                                
                        </div>
                    </div>
                    <div class="widget-content widget-content-area area_amcharts">
                        <div class="row">
                            <div *ngIf="loadingActionsStatistics" class="cp-spinner cp-bubble" style="margin: auto;display: block;margin-top: 15%;
                                margin-bottom: 15%;">
                            </div>
                            <div class="col-lg-12 mb-4" *ngIf="!loadingActionsStatistics">
                                <div class="container_chart">
                                    <div id="myChart_actions"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row layout-spacing mb-3" >
            <div class="col-lg-6 layout-spacing">
                <div class="statbox widget box box-shadow">
                    <div class="widget-header">
                        <div class="row">
                            <div class="col-xl-12 col-md-12 col-sm-12 col-12">
                                <h4>Nombre de clients par commercial</h4>
                            </div>                           
                        </div>
                    </div>
                    <div class="widget-content widget-content-area area_amcharts">
                        <div class="row">
                            <div *ngIf="loadingClientssStatistics" class="cp-spinner cp-bubble" style="margin: auto;display: block;margin-top: 15%;
                                margin-bottom: 15%;">
                            </div>
                            <div class="col-lg-12 mb-4" *ngIf="!loadingClientssStatistics">
                                <div class="container_chart">
                                    <div id="myChart_customers"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 layout-spacing container_amcharts">
                <div class="statbox widget box box-shadow">
                  <div class="widget-header">
                    <div class="row">
                      <div class="col-xl-12 col-md-12 col-sm-12 col-12">
                        <h4>Nombre d'actions annulées ou reportées par commercial</h4>
                      </div>
                    </div>
                  </div>
                  <div class="widget-content widget-content-area area_amcharts">
                    <div class="row">
                      <div *ngIf="loadingReportedCanceledStatistics" class="cp-spinner cp-bubble" style="margin: auto; display: block; margin-top: 15%; margin-bottom: 15%;"></div>
                      <div class="col-lg-12 mb-4" *ngIf="!loadingReportedCanceledStatistics">
                        <div class="container_chart">
                          <div id="actions_chart" style="width: 100%; height: 500px;"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
                         
        </div>
    </div>
</div>


        